<div class="form-row m-0">
  <mat-form-field  appearance="outline" class="input-bea w-100">
    <input matInput [value]="inputLabel" #searchTextField type="text" (input)="onInputChange($event)" [placeholder]="placeholder" [disabled]="disabled" />
      <!-- Icona "X" per il clear -->
      <button *ngIf="label && environment.serviceSlug == 'kit'" mat-icon-button matSuffix aria-label="Clear" (click)="clearAll()">
          <mat-icon>close</mat-icon>
      </button>
  </mat-form-field>
</div>
